



























import Event from '@/datatypes/event';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component(
  {
    name: 'DocumentEvents',
  },
)
export default class DocumentEvents extends Vue {
  @Prop() events: Array<Event> | undefined;
}
